
import EDBox from '../../../../../../../../BaseComponents/EDBox/EDBox';
import EDDatePicker from '../../../../../../../../BaseComponents/DatePicker/EDDatePicker';
import { useIsSmallScreen } from '../../../../../../../../Hooks/useFullscreenView';

interface IProps {
  startDate: string;
  setStartDate: (value: string) => void;
  isInvalidDate: (date: string) => boolean;
  isDateBehindCurrent: (date: string) => boolean;
}

const getStartDateErrorMessage = (
  startDate: string,
  isInvalidDate: (date: string) => boolean,
  isDateBehindCurrent: (date: string) => boolean
): string | undefined => {
  if (startDate && isInvalidDate(startDate)) {
    return `Ogiltigt värde "${startDate}" i Fråndatum`;
  }

  if (isDateBehindCurrent(startDate)) {
    return 'Datum är bakåt i tiden';
  }
  return undefined;
};

const CopyActivityDatePicker: React.FC<IProps> = ({
  startDate,
  setStartDate,
  isInvalidDate,
  isDateBehindCurrent,
}) => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <EDBox
      display="flex"
      width={isSmallScreen ? undefined : '340px'}
      paddingBottom={'5px'}
      paddingInline={'15px'}
      marginBottom={startDate ? '0px' : '10px'}
    >
      <EDDatePicker
        fullWidth
        label="Nytt Fråndatum"
        value={startDate}
        onChange={value => setStartDate(value)}
        allowOnlyNumbers
        required
        error={Boolean(startDate && isInvalidDate(startDate))}
        warning={isDateBehindCurrent(startDate)}
        helperText={getStartDateErrorMessage(
          startDate,
          isInvalidDate,
          isDateBehindCurrent
        )}
      />
    </EDBox>
  );
};

export default CopyActivityDatePicker;
